import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { MinusIcon, PlusIcon } from 'lucide-react';
import { navigation } from '../../data/navigation';
interface MobileNavProps {
  onNavigate: () => void;
}
export function MobileNav({
  onNavigate
}: MobileNavProps) {
  const [expanded, setExpanded] = useState<string | null>(null);
  return <nav id="mobile-nav" aria-label="Mobile" className="border-t border-line bg-paper lg:hidden" data-id="element-179" data-mp="3mgoky8q3jkqy">
      <ul className="mx-auto max-w-shell px-6 py-2" data-id="element-180" data-mp="2tssnh1spdot4">
        {navigation.map(section => {
        const isOpen = expanded === section.label;
        if (!section.items) {
          return <li key={section.label} className="border-b border-line last:border-b-0" data-id="element-181" data-mp="32tigxyuhr33o">
                <Link to={section.href} onClick={onNavigate} className="block py-4 font-display text-[26px] font-300 text-ink" data-id="element-182" data-mp="32r5rl0melqgl">
                  {section.label}
                </Link>
              </li>;
        }
        return <li key={section.label} className="border-b border-line last:border-b-0" data-id="element-183" data-mp="oc9vzdskzms5">
              <div className="flex items-center justify-between" data-id="element-184" data-mp="jcx6elabs1lv">
                <Link to={section.href} onClick={onNavigate} className="block flex-1 py-4 font-display text-[26px] font-300 text-ink" data-id="element-185" data-mp="jb40573mjjee">
                  {section.label}
                </Link>
                <button type="button" aria-expanded={isOpen} aria-controls={`m-${section.label.replace(/\s+/g, '-')}`} onClick={() => setExpanded(isOpen ? null : section.label)} className="flex h-10 w-10 items-center justify-center text-muted" data-id="element-186" data-mp="5l8uoj3znf5f">
                  <span className="sr-only" data-id="element-187" data-mp="3nsycsizm6yvg">
                    {isOpen ? 'Collapse' : 'Expand'} {section.label}
                  </span>
                  {isOpen ? <MinusIcon className="h-4 w-4" aria-hidden="true" data-id="element-188" data-mp="392vchdcckkjq" /> : <PlusIcon className="h-4 w-4" aria-hidden="true" data-id="element-189" data-mp="3d6tf3y0vsdhj" />}
                </button>
              </div>

              {isOpen && <ul id={`m-${section.label.replace(/\s+/g, '-')}`} className="border-l border-line pb-5 pl-5" data-id="element-190" data-mp="344ts8p36qf6o">
                  {section.items.map(item => <li key={item.label} data-id="element-191" data-mp="nldwf7o1xgp">
                      <Link to={item.href} onClick={onNavigate} className="flex items-baseline justify-between gap-4 py-2.5" data-id="element-192" data-mp="qpobubq5pft">
                        <span className="text-[15.5px] text-ink/80" data-id="element-193" data-mp="eoecbb139cp3">
                          {item.label}
                        </span>
                        {item.note && <span className="shrink-0 text-[11.5px] text-muted/70" data-id="element-194" data-mp="jh7cdllm3wuu">
                            {item.note}
                          </span>}
                      </Link>
                    </li>)}
                </ul>}
            </li>;
      })}
      </ul>

      <div className="mx-auto max-w-shell px-6 pb-8 pt-4" data-id="element-195" data-mp="28vq9io9kja24">
        <a href="#newsletter" onClick={onNavigate} className="label block bg-ink px-6 py-4 text-center text-paper" data-id="element-196" data-mp="28ycq1defszwh">
          Get the Sunday note
        </a>
      </div>
    </nav>;
}